export const API_URL = {
    GETWAY_API: process.env.REACT_APP_GETWAY_API + 'insurancebox/',
    GETWAY_DOCS_API: process.env.REACT_APP_GETWAY_API + 'insurancebox-docs/',
};

export const APIV = 1;
export const apikey = `insurancebox-ac1faa7b-9fe9-4483-9525-5cc4ce94c639`;
export const CURRENCY_SYMBOL = '₱';
export const DOC_UPLOAD_VALIDATION = { "minSize": 25000, "maxSize": 5000000 }
export const IDENTITY_PROOF_MIN_SIZE_BYTES = 25 * 1024;

export const FIELD_TYPE = {
    TEXT_BOX: 'tb',
    DROP_DOWN: 'dd',
    DROPDOWN_INPUT_FIELD: 'ddtb',
    SEARCHABLE_DROP_DOWN: 'sdd',
    READ_ONLY_TEXT_BOX: 'ro',
    DATE_PICKER: 'date',
    MOBILE_FIELD: 'mobile',
    STICKY_FIELD: "sticky",
    EMAIL: 'email',
    MARKET_MRP: 'market_mrp',
    CITY: 'city',
    STATE: 'state',
    LOCALITY: 'locality',
    RADIO_BOX: 'radio',
    MRP_UPPING: 'mrp_upping',
    CURRENCY: 'currency',
    FUTURE_DATE: 'future_date',
    TELEPHONE: 'telephone',
    CHECK_BOX: 'checkbox',
    SELECT_ADDON: 'select_addon',
    SUM: 'sum',
    TEXT_AREA: 'ta',
    MULTI_DROP_DOWN: 'mdd',
    INFO: 'static_info',
    MMV: 'mmv',
    DATE_TIME: 'date_time',
    SWITCH: 'switch',
    DATE_RANGE: 'trip_date_range'
}


export const ADD_ONS_TYPE = {
    BODILY_INJURY: 'bi',
    PROPERTY_DAMAGE: 'pd',
    PERSONAL_ACCIDENT: 'pa',
    RIOTS_STRIKES_CIVIL: 'rsc',
    TOWING_ROWDSIDE: 'tra',
    ACTS_OF_NATURE: 'an'
} 

export const REGEX_DECIMAL_VALIDATION = /^[0-9]*(\.[0-9]{0,2})?$/;

export const REDIRECT_URLS: any = {
	"beta" : "https://stage-sso.carmudi.com.ph/google?redirect=",
	"preprod" : "https://pre-sso.carmudi.com.ph/google?redirect=",
	"prod" : "https://sso.carmudi.com.ph/google?redirect=",
	"local" : "https://stage-sso.carmudi.com.ph/google?redirect="
}
let reactAppEnv: any = process.env.REACT_APP_ENV;
export const AGENT_WEB = 6;

export const REDIRECT_URL: any = REDIRECT_URLS[reactAppEnv]

export const INS_TYPE_COMPREHENSIVE = 1;
export const INS_TYPE_CTPL          = 2;
export const STATUS_TYPE = [{value:"submitted",label:"Submitted",key:"1"},{value:"policy_issued",label:"Issued",key:"2"},{value:"pending_payment",label:"Pending Payment",key:"3"},{value:"pending",label:"Pending Application",key:"4"}]

export const LEAD_LIST_HEADER_COLUMN:any= {"submitted":["Customer Name","Vehicle Details","Plate No" ,"Created On"],"policy_issued":["Customer Name","Vehicle Name","Plate No","Issue Date","Action"],"pending_payment":["Customer Name","Vehicle Name","Plate No","Pending Payment","Due Date","Status"],"pending":["Customer Name","Vehicle Name","Plate No","Created On"],"claim":["Customer Name","Vehicle Details","Policy No","Policy Expiry Date","Claim Status","Action"]}

export const LEAD_LIST_FILTER = {
    taskSummaryFilters: [
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mtd', label: 'MTD' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    travelTaskSummaryFilters: [
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mtd', label: 'MTD' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    pendingPaymentFilters: [
      { value: 'nd', label: 'Next 7 Days' },
      { value: 'nm', label: 'Next Month' },
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mdd', label: 'Missed Due Date' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    raised_soa : [
      { value: '1', label: 'Yes' },
      { value: '0', label: 'No' }
    ]
};


export const REGEX_DECIMAL_VALIDATION_8 = /^[0-9]*(\.[0-9]{0,8})?$/;


export const WITH_RULE_ENGINE = 1
export const WITHOUT_RULE_ENGINE = 2


export const DOCUMENT_CATEGORY: any = {
    "orcr": 1, "existing_policy": 3, "vehicle_photos": 4,"others":27
}

export const REGEX_EMAIL_VALIDATION = /^[^@]+@[^@]+\.[^@.]{2,5}$/;

export const APP_TYPE_AGENCY = 4;

export const CLAIM_TYPE_CREATED_SOURCE = {claimBox: 1, agentWeb: 2, agentApp: 3}
export const EFFECTIVITY_EXPIRY_INTERVAL = 60;

export const STATUS_CODES = {"success": 200, "failure": 400, 'unauthorized': 401, 'unavailable': 503}

export const SCREEN_SIZE = 768

export const REGEX_NUMBER_WITH_TWO_DECIMAL = /^[0-9]+(\.[0-9]{0,2})?$/;
export const DEFAULT_PAGE_NO = 1;
export const DEFAULT_PAGINATION_COUNT = 10;
export const DEFAULT_INPUTFIELD_LENGTH = 1000;
export const MAX_FILE_UPLOAD = 5;
export const MAX_OTP_TIMER = 59;
export const REGEX_EMAIL = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
export const REGEX_MOBILE = /^[9]\d{9}$/;
export const REGEX_CAMEL_CASE = /(?:^\w|[A-Z]|\b\w)/g;

export const BIKE_INS_VEHICLE_TYPE_ID = 11;
export const COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID = 12;

export const API_VERSION_V2 = 'v2';
export const LOGIN_TYPE = ['agency','sales_user']
export const OCR_EXIST_PARENT_ID=68
export const SUBTRACT_YEAR = { ONE: 1, TWO: 2 , THREE: 3, SIX: 6 }; 
export const ALLOW_MONTH = 6
export const LAST_MONTH = 11
export const DOC_COLOR_CODE = {
  OTHER:"#D8EAFF",
  VEHICLE:"#FFF1D6",
  OCR:"#BFF8FC"
}

export const FUEL_TYPE_EXCLUDE =["electric","hybrid"];
export const VEHICLE_USAGE_COMMERCIAL = 2
export const VEHICLE_TYPE_SUV = 7;
export const WHATSAPP_WEB_URL = "https://web.whatsapp.com/send?text=";
export const INSURANCE_COVERAGE = {vehicle:1,travel:2};
export const PAGE_TYPE = {
    PLAN_SELECTION: 3,
    TRAVELLER_DETAILS: 4,
    MAKE_PAYMENT: 5,
};
export const PAGE_TYPE_STEP_MAP: Record<number, string> = {
    [PAGE_TYPE.PLAN_SELECTION]: "plan_selection",
    [PAGE_TYPE.TRAVELLER_DETAILS]: "traveller_details",
    [PAGE_TYPE.MAKE_PAYMENT]: "checkout",
};
export const TRAVEL_STEPS = [
    { key: "trip_details", title: "Trip Details" },
    { key: "plan_selection", title: "Plan Selection" },
    { key: "traveller_details", title: "Traveller Details" },
    { key: "checkout", title: "Checkout" },
];
export const TRAVEL_CHECKOUT_CONFIG_KEY = "make_payment";
export const TRAVEL_LOCKED_AFTER_LEAD_CREATE_STEPS = ["trip_details", "plan_selection", "traveller_details"];
export const DEFAULT_MAX_TRAVELLER_COUNT = 10;
export const MAX_DESTINATION_COUNTRY_COUNT = 10;
export const MAX_SINGLE_TRIP_DURATION_DAYS = 180;
export const MIN_ADULT_AGE = 18;
export const MAX_ADULT_AGE = 75;
export const ASIA_REGION_ID = 2
export const MOBILE_PREFIX = "+63"
export const TRAVEL_STATUS_MAP = {
  submitted: {
    status_id: 1,
    sub_status_id: 2,
  },
  quotation_shared: {
    status_id: 1,
    sub_status_id: 1,
  },
  policy_issued: {
    status_id: 3,
    sub_status_id:4,
  },
};
export const PHILIPPINE_COUNTRY_ID = 52
export const SOURCE = {
  WEB:1
}
